import border from './border';
import brand from './brand';
import children from './children';
import collapseAt from './collapse-at';
import container from './container';
import dropdownContainer from './dropdown-container';
import innerContainer from './inner-container';
import item from './item';
import toggle from './toggle';
import wrapper from './wrapper';

const navbar = {
  ...collapseAt,
  border,
  brand,
  children,
  container,
  dropdownContainer,
  innerContainer,
  item,
  toggle,
  wrapper
};

export default navbar;
